import { render } from "./SalesByCategoryChart.vue?vue&type=template&id=071a7e63&scoped=true&ts=true"
import script from "./SalesByCategoryChart.vue?vue&type=script&lang=ts"
export * from "./SalesByCategoryChart.vue?vue&type=script&lang=ts"

import "./SalesByCategoryChart.vue?vue&type=style&index=0&id=071a7e63&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071a7e63"]])

export default __exports__